import { IconPlus } from "@synthesis/shared-icons";
import { Button, Tag } from "@synthesis/shared-ui";

import { CONSTRUCTOR_SERVICE_STATUS_TAG } from "../../constructor-services-page/constructor-services-page.lib";
import { useServiceDetail } from "../hooks/use-service-detail";
import { usePageStore } from "../service-detail-page.lib";

/** Шапка карточки услуги: название со статусом и кнопка регистрации версии (модалка через стор). */
export const ServiceDetailHeader = () => {
  const store = usePageStore()!;
  const { service } = useServiceDetail();

  if (!service) {
    return null;
  }

  const { tagStatus, label, withLeftIcon } = CONSTRUCTOR_SERVICE_STATUS_TAG[service.status];

  return (
    <div className="flex items-start justify-between gap-6">
      <div className="flex min-w-0 flex-col gap-1">
        <div className="flex items-center gap-3">
          <h1 className="heading-h4 text-type-common">{service.title}</h1>
          <Tag
            size="status"
            status={tagStatus}
            leftIcon={withLeftIcon ? <span className="size-2.5 rounded-full bg-current" aria-hidden /> : undefined}
          >
            {label}
          </Tag>
        </div>
        <p className="subtitle-sm text-type-minor">{service.description}</p>
      </div>
      <Button
        theme="primary"
        size="sm"
        leftIcon={<IconPlus className="size-5" aria-hidden />}
        onClick={() => store.setPopupAction({ type: "register-version" })}
      >
        Зарегистрировать версию
      </Button>
    </div>
  );
};
